import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './ArtGraphique.css';

const CATEGORIES = [
  { key: '', label: 'Tout' },
  { key: 'dessins', label: '✏️ Ses dessins' },
  { key: 'lettres', label: '✉️ Ses lettres' },
  { key: 'mots', label: '💬 Ses petits mots' }
];

export default function ArtGraphique() {
  const { user, token } = useAuth();
  const [items, setItems] = useState([]);
  const [activeCategory, setActiveCategory] = useState('');
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', category: 'dessins', order: 0 });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchItems = async (cat = '') => {
    const url = cat ? `/api/graphic-art?category=${cat}` : '/api/graphic-art';
    const res = await fetch(url);
    const data = await res.json();
    setItems(data);
  };

  useEffect(() => { fetchItems(activeCategory); }, [activeCategory]);

  const handleSubmit = async () => {
    if (!file || !form.title || !form.category) return;
    setLoading(true);
    const fd = new FormData();
    fd.append('image', file);
    fd.append('title', form.title);
    fd.append('description', form.description);
    fd.append('category', form.category);
    fd.append('order', form.order);
    await fetch('/api/graphic-art', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: fd
    });
    setLoading(false);
    setShowForm(false);
    setForm({ title: '', description: '', category: 'dessins', order: 0 });
    setFile(null);
    fetchItems(activeCategory);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette œuvre ?')) return;
    await fetch(`/api/graphic-art/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    setSelected(null);
    fetchItems(activeCategory);
  };

  return (
    <div className="ag-page">
      <div className="ag-header">
        <div className="ag-eyebrow">Michael — Art graphique</div>
        <h1 className="ag-title">Son art graphique, <em>ses mots dessinés</em></h1>
        <p className="ag-intro">Michael Jackson ne s'exprimait pas seulement par la musique — ses dessins, ses lettres et ses petits mots manuscrits révèlent un artiste complet, sensible et profondément humain.</p>
      </div>

      <div className="ag-toolbar">
        <div className="ag-tabs">
          {CATEGORIES.map(c => (
            <button
              key={c.key}
              className={`ag-tab${activeCategory === c.key ? ' active' : ''}`}
              onClick={() => setActiveCategory(c.key)}
            >{c.label}</button>
          ))}
        </div>
        {user?.isAdmin && (
          <button className="ag-btn-add" onClick={() => setShowForm(!showForm)}>
            + Ajouter
          </button>
        )}
      </div>

      {showForm && user?.isAdmin && (
        <div className="ag-form">
          <input placeholder="Titre" value={form.title} onChange={e => setForm({...form, title: e.target.value})} />
          <input placeholder="Description (optionnel)" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
          <select value={form.category} onChange={e => setForm({...form, category: e.target.value})}>
            <option value="dessins">Ses dessins</option>
            <option value="lettres">Ses lettres</option>
            <option value="mots">Ses petits mots</option>
          </select>
          <input type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} />
          <button onClick={handleSubmit} disabled={loading}>{loading ? 'Envoi...' : 'Publier'}</button>
          <button className="ag-btn-cancel" onClick={() => setShowForm(false)}>Annuler</button>
        </div>
      )}

      <div className="ag-masonry">
        {items.map(item => (
          <div key={item._id} className="ag-card" onClick={() => setSelected(item)}>
            <div className="ag-card-img">
              <img src={item.imageUrl} alt={item.title} loading="lazy" />
            </div>
            <div className="ag-card-body">
              <div className={`ag-cat ag-cat-${item.category}`}>
                <span className="ag-dot"></span>
                {item.category === 'dessins' ? 'Ses dessins' : item.category === 'lettres' ? 'Ses lettres' : 'Ses petits mots'}
              </div>
              <div className="ag-card-title">{item.title}</div>
              {item.description && <div className="ag-card-desc">{item.description}</div>}
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <p className="ag-empty">Aucune œuvre dans cette catégorie pour l'instant.</p>
        )}
      </div>

      {selected && (
        <div className="ag-lightbox" onClick={() => setSelected(null)}>
          <div className="ag-lightbox-inner" onClick={e => e.stopPropagation()}>
            <button className="ag-lightbox-close" onClick={() => setSelected(null)}>✕</button>
            <img src={selected.imageUrl} alt={selected.title} />
            <div className={`ag-cat ag-cat-${selected.category}`}>
              <span className="ag-dot"></span>
              {selected.category === 'dessins' ? 'Ses dessins' : selected.category === 'lettres' ? 'Ses lettres' : 'Ses petits mots'}
            </div>
            <h2>{selected.title}</h2>
            {selected.description && <p>{selected.description}</p>}
            {user?.isAdmin && (
              <button className="ag-btn-delete" onClick={() => handleDelete(selected._id)}>Supprimer</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
